<!--
Auto-generated by: https://github.com/threlte/threlte/tree/main/packages/gltf
Command: npx @threlte/gltf@2.0.3 /Users/nrumak/Development/square-dt-labs/static/nrumak/phone_modified.glb -u -t -P
-->

<script module lang="ts">
  import { Group, Material, Mesh } from 'three';
  import { T, type Props } from '@threlte/core';
  import { useGltf, useSuspense } from '@threlte/extras';
  import type { Snippet } from 'svelte';

  type GLTFResult = {
    nodes: {
      Mesh002: Mesh;
      Mesh002_1: Mesh;
      Mesh002_2: Mesh;
    };
    materials: {};
  };

  let modelUrl = '';

  const load = () => {
    const suspend = useSuspense();
    return suspend(useGltf<GLTFResult>(modelUrl));
  };

  export const preload = async (url: string) => {
    modelUrl = url;
    try {
      await load();
    } catch (err) {
      return console.error('Failed to load model', err);
    }
  };
</script>

<script lang="ts">
  let {
    fallback,
    error,
    children,
    ref = $bindable(),
    matcaps,
    fallbackMaterial,
    ...props
  }: Props<Group> & {
    ref?: Group;
    matcaps: {
      bezel: Material;
      brushedTitanium: Material;
      phoneGlass: Material;
      phone_screen: Material;
    };
    fallbackMaterial: Material;
    children?: Snippet<[{ ref: Group | undefined }]>;
    fallback?: Snippet;
    error?: Snippet<[{ error: Error }]>;
  } = $props();

  let materials: any = $state(matcaps);

  $effect(() => {
    materials = matcaps ?? {
      bezel: fallbackMaterial,
      brushedTitanium: fallbackMaterial,
      phoneGlass: fallbackMaterial,
      phone_screen: fallbackMaterial,
    };
  });

  const gltf = load();
</script>

<T is={new Group()} dispose={false} {...props}>
  {#await gltf}
    {@render fallback?.()}
  {:then gltf}
    <T.Group rotation={[Math.PI / 2, 0, 0]} scale={0.045}>
      <!-- bezel -->
      <T.Mesh geometry={gltf.nodes.Mesh002.geometry} material={materials.bezel} />
      <!-- phone frame -->
      <T.Mesh geometry={gltf.nodes.Mesh002_1.geometry} material={materials.brushedTitanium} />
      <!-- phone frame -->
      <T.Mesh geometry={gltf.nodes.Mesh002_2.geometry} material={materials.phone_screen} />
    </T.Group>
  {:catch err}
    {@render error?.({ error: err })}
  {/await}
  {@render children?.({ ref })}
</T>
